module.exports = __webpack_public_path__ + "img/5.95736461.jpg";